import { createService, z } from '@betty/toolkit/api';

export const ReassessAccountRequestSchema = z.object({
  hasAccountChanges: z.boolean(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  addressLine1: z.string().optional(),
  city: z.string().optional(),
  provinceCode: z.string().optional(),
  postalCode: z.string().optional(),
  occupation: z.string().optional(),
  phoneCode: z.string(),
  phoneNumber: z.string().optional(),
  isPep: z.boolean().optional(),
});

export const ReassessAccountResponseSchema = z.object({
  isLoginAllowed: z.boolean(),
});

export default createService(
  {
    reassessAccount: {
      method: 'PUT',
      url: '/reassessment',
      requestSchema: ReassessAccountRequestSchema,
      responseSchema: ReassessAccountResponseSchema,
    },
  },
  ({ userId }) => `/Accounts/${userId}`,
);
